<script>
import AppointmentRequest from './appointment-request.vue'

export default {
  name: 'MessageComposer',
  components: { AppointmentRequest },
  props: {
    value: { type: String, default: '' },
    rows: { type: Number, default: 1 },
    navRelative: { type: Boolean, default: false },
    navPadding: { type: Boolean, default: false },
    showMeetingRequest: { type: Boolean, default: false },
    allowAttachments: { type: Boolean, default: true },
    maxFileSize: { type: Number, default: 1 * 1024 * 1024 },
    acceptTypes: { type: String, default: 'image/*,.pdf,.txt' },
  },

  data() {
    return {
      showMenu: false,
      showAppointmentForm: false,
      selectedFile: null,
    }
  },

  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click()
      this.showMenu = false
    },

    onFileSelected(event) {
      const file = event.target.files[0]
      if (!file) return
      if (file.size > this.maxFileSize) {
        alert(`Datei zu groß. Maximal ${this.maxFileSize / 1024 / 1024} MB.`)
        this.$refs.fileInput.value = ''
        return
      }
      this.selectedFile = file
      this.$emit('file-selected', file)
      this.showMenu = false
    },

    removeFile() {
      this.selectedFile = null
      this.$refs.fileInput.value = ''
      this.$emit('file-selected', null)
    },

    getEndTime(startTime, mins) {
      let date = new Date()
      const [hh, mm] = startTime.split(':').map(Number)
      date.setUTCHours(hh, mm + mins, 0, 0)
      return date.toISOString().slice(11, 16)
    },

    onAppointmentSubmit(info) {
      this.showAppointmentForm = false
      this.showMenu = false
      let endTime = this.getEndTime(info.time, info.duration)
      this.$emit('meeting-request', {
        date: info.date,
        time: info.time,
        end: endTime,
        duration: info.duration,
        subject: info.subject,
        message: info.message,
      })
    },

    focus() {
      this.$refs.postInput.focus()
    },
  },
}
</script>

<template>
  <div :class="{'c-navbar': navRelative, 'fixed-bottom': !navRelative, 'c-nav-padding': navPadding}">

    <div v-if="showAppointmentForm" class="p-3 bg-light border-top">
      <appointment-request @submit="onAppointmentSubmit" @cancel="showAppointmentForm = false" />
    </div>

    <div v-if="selectedFile" class="attachment-preview px-3 py-1 bg-light border-top d-flex align-items-center">
      <i class="fas fa-paperclip me-1"></i>
      <span class="text-truncate">{{ selectedFile.name }}</span>
      <button @click="removeFile" class="btn btn-sm ms-2 p-0">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <nav class="nav navbar navbar-light bg-light">
      <form style="width:100%">
        <div class="input-group px-1">

          <div v-if="allowAttachments || showMeetingRequest" class="dropdown">
            <button class="btn" type="button" @click.prevent="showMenu = !showMenu">
              <span class="fas fa-plus"></span>
            </button>
            <div v-if="showMenu" class="composer-menu">
              <button v-if="allowAttachments" type="button" class="dropdown-item" @click="triggerFileInput">
                <i class="fas fa-paperclip"></i> Anhang
              </button>
              <button v-if="showMeetingRequest" type="button" class="dropdown-item" @click="showAppointmentForm = !showAppointmentForm; showMenu = false">
                <i class="fas fa-calendar"></i> Termin-Anfrage
              </button>
            </div>
          </div>

          <input type="file" ref="fileInput"
            :accept="acceptTypes"
            :style="{display:'none'}"
            @change="onFileSelected"
          />

          <textarea ref="postInput" class="form-control"
            :value="value"
            @input="$emit('input', $event.target.value)"
            @keydown.enter.exact.prevent="$emit('send')"
            :rows="rows"
          ></textarea>

          <button class="btn" @click.prevent="$emit('send')">
            <span class="far fa-paper-plane"></span>
          </button>
        </div>
      </form>
    </nav>
  </div>
</template>

<style scoped>
.c-navbar {
  flex-shrink: 0;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}

.c-nav-padding {
  padding-left: 15px;
  padding-right: 15px;
}

.composer-menu {
  position: absolute;
  bottom: 100%;
  left: 0;
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1050;
  min-width: 160px;
  margin-bottom: 4px;
}

.composer-menu .dropdown-item {
  display: block;
  width: 100%;
  padding: 0.5rem 1rem;
  text-align: left;
  background: none;
  border: none;
  cursor: pointer;
}

.composer-menu .dropdown-item:hover {
  background-color: #f8f9fa;
}

.attachment-preview {
  font-size: 0.85rem;
}
</style>
